import { render, staticRenderFns } from "./CarrierInvoice.vue?vue&type=template&id=0f0a8cba&scoped=true&"
import script from "./CarrierInvoice.vue?vue&type=script&lang=js&"
export * from "./CarrierInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CarrierInvoice.vue?vue&type=style&index=0&id=0f0a8cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a8cba",
  null
  
)

export default component.exports